export default () => (
	<div class="rias-content col-span-full mx-auto px-4 pb-8">
		<h2 class="headline-lg mb-6">Terms &amp; Conditions</h2>

		<p class="mb-6 text-gray-700 leading-relaxed">
			RIAS-regs is provided to you as a joint venture between RIAS Services Limited and Home
			Energy and Data Services Ltd.
		</p>

		<ol class="terms-list">
			<li>
				<h3 class="font-semibold text-lg">Your Account</h3>
				<p class="mt-2">
					If you use the website, you are responsible for maintaining the confidentiality
					of your account and password and for restricting access to your computer or
					other device to prevent unauthorised access to your account. You agree to accept
					responsibility for all activities that occur under your account or password. You
					should take all necessary steps to ensure that the password is kept confidential
					and secure and should inform us immediately if you have any reason to believe
					that your password has become known to anyone else, or if the password is being,
					or is likely to be, used in an unauthorised manner. Please ensure that the
					details you provide us with are correct and complete and inform us immediately
					of any changes to the information that you provided when registering. You can
					access and update much of the information you provided us with in the Your
					Details area of the website. Home Energy and Data Services Ltd. reserves the
					right to refuse access to the website, terminate accounts, remove or edit
					content, or cancel orders at our discretion. If we cancel an order, it will be
					without charge to you.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">Access to RIAS-regs</h3>
				<p class="mt-2">
					We will do our utmost to ensure that availability of the website will be
					uninterrupted and that transmissions will be error-free. However, due to the
					nature of the Internet, this cannot be guaranteed. Also, your access to the
					website may also be occasionally suspended or restricted to allow for repairs,
					maintenance, or the introduction of new facilities or services, updates,
					improvements, or new functionality. We will attempt to limit the frequency and
					duration of any such suspension or restriction.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">Licence for website access</h3>
				<p class="mt-2">
					Home Energy and Data Services Ltd. grants you a limited licence to access and
					make personal use of this website, but not to download (other than page caching)
					or modify it, or any portion of it, except with express written consent of Home
					Energy and Data Services Ltd. This licence does not include any resale or
					commercial use of this website or its contents; any collection and use of any
					descriptions, any derivative use of this website or its contents; any
					downloading or copying of account information for the benefit of another
					company; or any use of data mining, robots, or similar data gathering and
					extraction tools. This website or any portion of this website may not be
					reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited
					for any commercial purpose without our express written consent. You may not
					frame or use framing techniques to enclose any trademark, logo, or other
					proprietary information (including images, text, page layout, or form) of Home
					Energy and Data Services Ltd. and its affiliates without express written
					consent. You may not use any meta tags or any other “hidden text” utilising Home
					Energy and Data Services Ltd. or its affiliates’ names or trademarks without the
					express written consent of Home Energy and Data Services Ltd. Any unauthorised
					use terminates the permission or license granted by Home Energy and Data
					Services Ltd. You are granted a limited, revocable, and non-exclusive right to
					create a hyperlink to the Main page of www.RIAS-regs.co.uk as long as the link
					does not portray Home Energy and Data Services Ltd., its affiliates, or their
					products or services in a false, misleading, derogatory, or otherwise offensive
					matter. You may not use any Home Energy and Data Services Ltd. logo or other
					proprietary graphic or trademark as part of the link without our express written
					consent. Any unauthorised use terminates the permission or licence granted to
					you.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">Your conduct</h3>
				<p class="mt-2 mb-3">
					You must not use the website in any way that causes, or is likely to cause, the
					website or access to it to be interrupted, damaged or impaired in any way. You
					understand that you, and not Home Energy and Data Services Ltd., are responsible
					for all electronic communications and content sent from your computer to us and
					you must use the website for lawful purposes only. You must not use the website
					for any of the following:
				</p>

				<ul class="list-disc pl-6 space-y-2">
					<li>
						for fraudulent purposes, or in connection with a criminal offence or other
						unlawful activity
					</li>
					<li>
						to send, use or reuse any material that is illegal, offensive, abusive,
						indecent, defamatory, obscene or menacing; or in breach of copyright,
						trademark, confidence, privacy or any other right; or is otherwise injurious
						to third parties; or objectionable; or which consists of or contains
						software viruses, political campaigning, commercial solicitation, chain
						letters, mass mailings or any “spam”
					</li>
					<li>to cause annoyance, inconvenience or needless anxiety</li>
				</ul>
			</li>

			<li>
				<h3 class="font-semibold text-lg">
					Copyright, authors’ rights and database rights
				</h3>
				<p class="mt-2">
					All content included on the website, such as text, graphics, logos, button
					icons, images, audio clips, digital downloads, data compilations, and software,
					is the property of Home Energy and Data Services Ltd., its affiliates or its
					content suppliers and is protected by copyright, authors rights and database
					right laws. The compilation of all content on this website is the exclusive
					property of Home Energy and Data Services Ltd. and its affiliates and is
					protected by United Kingdom and international copyright and database right laws.
					All software used on this website is the property of Home Energy and Data
					Services Ltd., our affiliates or our software suppliers and is protected by
					international copyright and authors rights laws. You may not systematically
					extract and/or re-utilise parts of the contents of the website without Home
					Energy and Data Services Ltd.’s express written consent. In particular, you may
					not utilise any data mining, robots, or similar data gathering and extraction
					tools to extract (whether once or many times) for re-utilisation of any
					substantial parts of this website, without Home Energy and Data Services Ltd.’s
					express written consent.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">Copyright claims</h3>
				<p class="mt-2">
					Home Energy and Data Services Ltd. and its affiliates respect the intellectual
					property of others. If you believe that your work has been copied in a way that
					constitutes copyright infringement, please follow our Notice and Procedure for
					Making Claims of Copyright Infringement.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">Our contract</h3>
				<p class="mt-2">
					When you place an order to purchase a certificate from Home Energy and Data
					Services Ltd., we will send you an e-mail confirming receipt of your order and
					containing the details of your order. Your order represents an offer to us to
					purchase a certificate, which is accepted by us when we send e-mail confirmation
					to you.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">Electronic communications</h3>
				<p class="mt-2">
					When you visit www.RIAS-regs.co.uk or send e-mails to us, you are communicating
					with us electronically. We communicate with you by e-mail or by posting notices
					on the website. For contractual purposes, you consent to receive communications
					from us electronically and you agree that all agreements, notices, disclosures
					and other communications that we provide to you electronically satisfy any legal
					requirement that such communications be in writing. This condition does not
					affect your statutory rights.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">Losses</h3>
				<p class="mt-2">
					We will not be responsible for any business loss (including, but not limited to,
					loss of profits, revenue, contracts, anticipated savings, data, goodwill or
					wasted expenditure) or any other indirect or consequential loss that is not
					reasonably foreseeable to both you and us when you commenced using the website
					or when a contract for the sale of goods by us to you was formed. To the fullest
					extent permitted by law, our total liability arising from your use of the
					website is limited to the fees you have paid in the last 12 months, or £100,
					whichever is greater.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">
					Alteration of Service or Amendments to the Conditions
				</h3>
				<p class="mt-2">
					We reserve the right to make changes to our website, policies, and these
					Conditions of Use &amp; Sale at any time. You will be subject to the policies
					and Conditions of Use &amp; Sale in force at the time that you use the website
					or that you order goods from us, unless any change to those policies or these
					conditions is required to be made by law or government authority (in which case
					it will apply to orders previously placed by you). If any of these conditions is
					deemed invalid, void, or for any reason unenforceable, that condition will be
					deemed severable and will not affect the validity and enforceability of any
					remaining condition.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">Events beyond our reasonable control</h3>
				<p class="mt-2">
					We will not be held responsible for any delay or failure to comply with our
					obligations under these conditions if the delay or failure arises from any
					cause, which is beyond our reasonable control. This condition does not affect
					your statutory rights.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">Waiver</h3>
				<p class="mt-2">
					If you breach these conditions and we take no action, we will still be entitled
					to use our rights and remedies in any other situation where you breach these
					conditions.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">Governing law and jurisdiction</h3>
				<p class="mt-2">
					These conditions are governed by and construed in accordance with the laws of
					Scotland, and the parties submit to the exclusive jurisdiction of the Scottish
					courts.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">Privacy</h3>
				<p class="mt-2">
					Your use of the website is also governed by our Privacy Notice, which explains
					how we process personal data in compliance with UK GDPR and the Data Protection
					Act 2018. Please refer to the Privacy Policy page.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">Termination</h3>
				<p class="mt-2">
					We may suspend or terminate your access to the website immediately if you breach
					these terms or your account is misused. Upon termination, your right to access
					the website ceases.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">Third-Party Links and Data</h3>
				<p class="mt-2">
					The website may contain links or rely on data from third-party sources. We are
					not responsible for the accuracy or availability of third-party content.
				</p>
			</li>

			<li>
				<h3 class="font-semibold text-lg">Our details</h3>

				<p class="mt-2">
					RIAS-regs.co.uk is a trading name for RIAS Services Limited and Home Energy and
					Data Services Limited.
				</p>

				<p class="mt-4">
					Any enquiries please contact:{" "}
					<a href="mailto:support@home-data.co.uk">support@home-data.co.uk</a>
				</p>
			</li>
		</ol>
	</div>
);
